const S = "LastSearchesService";
export {
  S as LAST_SEARCHES_SERVICE
};
